<!-- 左侧菜单栏 -->
<template>
  <div :class="{ 'has-logo': showLogo }" class="sidebar-container">
    <logo v-if="showLogo" :collapse="isCollapse" />
    <el-scrollbar wrap-class="scrollbar-wrapper">
      <!-- :text-color="getMenuTextColor"
              :background-color="getMenuBackground" -->
      <el-menu :default-active="activeMenu" :collapse="isCollapse" :unique-opened="true" :active-text-color="theme"
        :collapse-transition="false" mode="vertical" :class="sideTheme">
        <sidebar-item v-for="(route, index) in sidebarRouters" :key="route.path + index" :item="route"
          :base-path="route.path" />
      </el-menu>
    </el-scrollbar>
  </div>
</template>

<script setup name="Sidebar">
import Logo from "./Logo";
import SidebarItem from "./SidebarItem";
// import variables from "@/assets/styles/theme.module.scss";
import useAppStore from "@/store/modules/app";
import useSettingsStore from "@/store/modules/settings";
import usePermissionStore from "@/store/modules/permission";

const route = useRoute();
const appStore = useAppStore();
const settingsStore = useSettingsStore();
const permissionStore = usePermissionStore();

const sidebarRouters = computed(() => permissionStore.sidebarRouters);
const showLogo = computed(() => settingsStore.sidebarLogo);
const sideTheme = computed(() => settingsStore.sideTheme);
const theme = computed(() => settingsStore.theme);
const isCollapse = computed(() => !appStore.sidebar.opened);

// // 获取菜单背景色
// const getMenuBackground = computed(() => {
//   if (settingsStore.isDark) {
//     return "var(--sidebar-bg)";
//   }
//   return sideTheme.value === "theme-dark"
//     ? variables.menuBg
//     : variables.menuLightBg;
// });

// 获取菜单文字颜色
// const getMenuTextColor = computed(() => {
//   if (settingsStore.isDark) {
//     return "var(--sidebar-text)";
//   }
//   return sideTheme.value === "theme-dark"
//     ? variables.menuText
//     : variables.menuLightText;
// });

const activeMenu = computed(() => {
  const { meta, path } = route;
  if (meta.activeMenu) {
    return meta.activeMenu;
  }
  return path;
});
</script>

<style lang="scss" scoped>
.sidebar-container {
  // background-color: v-bind(getMenuBackground);
  // background-image: url("../../../assets/images/manage/bg-left.png");
  // background-size: 100% 100%;
  // padding: 3px;
  background-color: var(--sidebar-bg);

  // .scrollbar-wrapper {
  // background-color: v-bind(getMenuBackground);
  // }
  .el-scrollbar {
    height: calc(100% - var(--el-menu-logo-height));
    overflow-y: auto;
  }

  // .el-menu {
  //   border: none;
  //   height: 100%;
  //   width: 100% !important;
  //   // 国电修改--整体背景(不包含下拉)
  //   background-color: transparent;

  // .el-menu-item {
  // background-color: var(--sidebar-bg);
  // }

  // .el-menu-item,
  // .el-sub-menu__title {
  //   font-weight: 400;
  //   font-size: 16px;
  //   color: rgba(255, 255, 255, 0.55);

  //   &:hover {
  //     background-color: var(--menu-hover, rgba(0, 0, 0, 0.06)) !important;
  //   }
  // }

  // .el-menu-item {
  //   // color: v-bind(getMenuTextColor);

  //   &.is-active {
  //     color: var(--menu-active-text, #409eff);
  //     background-color: var(--menu-hover, rgba(0, 0, 0, 0.06)) !important;
  //   }
  // }

  // .el-sub-menu__title {
  //   // color: v-bind(getMenuTextColor);
  // }
  // }
}
</style>
